/* global s */
'use strict';

class BuyMobileRecharge {
	constructor() {
		// console.log('BuyMobileRechargeV4');
		this.initial_state = s.options._buy_mobile_recharge_options.state;
		this.location = s.options._buy_mobile_recharge_options.location;
		this.base_url = s.options._buy_mobile_recharge_options.base_url;
		this.store_name = s.options._buy_mobile_recharge_options.store_name;
		this.display_preselected_operator = s.options._buy_mobile_recharge_options.display_preselected_operator;
		this.add_tello_as_operator = s.options._buy_mobile_recharge_options.add_tello_as_operator;
		this.add_custom_operators = s.options._buy_mobile_recharge_options.add_custom_operators;
		this.initial_hero_title = s.options._buy_mobile_recharge_options.initial_hero_title;
		this.initial_seo_slot1 = s.options._buy_mobile_recharge_options.initial_seo_slot1;
		this.initial_seo_slot2 = s.options._buy_mobile_recharge_options.initial_seo_slot2;
		this.banner_promo_code = s.options._buy_mobile_recharge_options.banner_promo_code;
		this.new_value_promo_format = s.options._buy_mobile_recharge_options.new_value_promo_format;

		this.fields = {
			holder: document.querySelector('#buy-mr-holder'),
			form: document.querySelector('#form_buy_mr'),
			form_fields: document.querySelector('#form-fields'),

			country: document.querySelector('#country'),
			country_input: document.querySelector('[data-country-search-input]'), // Related to A/B Test - 58510_A_B_remove_steps_section

			operator_holder: document.querySelector('#operator-holder'),
			operator_content: document.querySelector('#operator-content'),
			operator_options_content: document.querySelector('#operator-options-content'),
			operator_banner_holder: document.querySelector('#operator-banner-holder'),
			operator_banner_content: document.querySelector('#operator-banner-content'),

			account_fields_holder: document.querySelector('#account-fields-holder'),
			account_fields_content: document.querySelector('#account-fields-content'),

			nickname_fields_holder: document.querySelector('#nickname-fields-holder'),

			amount_holder: document.querySelector('#amount-holder'),
			amount_content: document.querySelector('#amount-content'),
			amount_banner_holder: document.querySelector('#amount-banner-holder'),
			amount_banner_content: document.querySelector('#amount-banner-content'),

			notify_holder: document.querySelector('#notify-holder'),

			sms_notify_holder: document.querySelector('#sms-notify-holder'),
			sms_notify_trigger: document.querySelector('#sms-notify-trigger'),
			sms_notify_trigger_label: document.querySelector('#sms-notify-trigger-label'),
			sms_notify_form_group: document.querySelector('#sms-notify-form-group'),
			sms_notify_input_holder: document.querySelector('#sms-notify-input-holder'),
			sms_notify_input: document.querySelector('#sms-notify-input'),
			sms_notify_input_mask: document.querySelector('#sms-notify-input-mask'),
			sms_notify_input_prefix: document.querySelector('#sms-notify-input-prefix'),
			sms_notify_message: document.querySelector('#sms-notify-message'),
			sms_notify_message_char_left: document.querySelector('#sms-notify-message-char-left'),

			email_notify_holder: document.querySelector('#email-notify-holder'),
			email_notify_trigger: document.querySelector('#email-notify-trigger'),
			email_notify_trigger_label: document.querySelector('#email-notify-trigger-label'),
			email_notify_form_group: document.querySelector('#email-notify-form-group'),
			email_notify_input_holder: document.querySelector('#email-notify-input-holder'),
			email_notify_input: document.querySelector('#email-notify-input'),
			email_notify_message: document.querySelector('#email-notify-message'),
			email_notify_message_char_left: document.querySelector('#email-notify-message-char-left'),

			submit_holder: document.querySelector('#submit-holder'),
			submit_button: document.querySelector('#buy-button-mr'),
			submit_message_holder: document.querySelector('#submit-message-holder'),

			last_recharged_form: document.querySelector('#previous_orders')
		}
		this.fetcher = {};
		this.promise = {};

		this.initial_preselect_operator_group = false;

		this.mr = new MobileRechargeV4({
			'defaults': {
				'new_value_promo_format': this.new_value_promo_format
			},
			'state': this.initial_state,
			'base_url': this.base_url,
			'location': this.location,
			'fields': this.fields,
			'add_tello_as_operator': this.add_tello_as_operator,
			'add_custom_operators': this.add_custom_operators,
		});

		this.pageEvents();
	}

	pageEvents() {
		const _this = this;
		const url_params = new URLSearchParams(window.location.search);
		const order_product = url_params.get('order_product');

		if (order_product === 'new') {
			window.history.replaceState(_this.mr.state, 'Title', s.url(_this.base_url, {}));
		}

		if (_this.initial_state.country.code) {
			_this.changeCountry(_this.initial_state.country.code);
		}

		if (_this.fields.country) {
			_this.fields.country.addEventListener('change', (event) => {
				_this.changeCountry(event.target.value);
			});
		}

		if (_this.fields.country_input && _this.fields.country_input.dataset.countrySearchInput === '1') {
			const observerOptions = { attributes: true, attributeFilter: ["data-country-code"] };

			const callback = (mutationList, observer) => {
				for(const mutation of mutationList){
					if (mutation.type === "attributes" && mutation.attributeName === "data-country-code") {
						_this.changeCountry(mutation.target.dataset.countryCode);
					}
				}
			}

			const observer = new MutationObserver(callback);
			observer.observe(_this.fields.country_input, observerOptions);
		}

		// Bind click events for dynamic content
		document.addEventListener('click', (event) => {
			const operator_button = event.target.closest('.operator_button');
			const assign_nickname_trigger = event.target.closest('#assign_nickname_trigger');

			if (operator_button) {
				_this.bindOperatorEvent(operator_button);
			}

			if (assign_nickname_trigger) {
				_this.mr.showElement(document.querySelector('#nickname_holder'));
				_this.mr.hideElement(document.querySelector('#assign_nickname_holder'));
			}
		});

		if (_this.initial_state.nickname || _this.mr.state.nickname) {
			_this.mr.showElement(document.querySelector('#nickname_holder'));
			_this.mr.hideElement(document.querySelector('#assign_nickname_holder'));
		}

		// Bind key events for dynamic content
		document.addEventListener('keydown', (event) => {
			if (event.key === ' ' || event.key === 'Spacebar') {
				const operator_button = event.target.closest('.operator_button');

				if (operator_button) {
					event.preventDefault(); // prevent page scroll when div is focused
					_this.bindOperatorEvent(operator_button);
				}
			}
		});

		// Last recharges events
		if (_this.fields.last_recharged_form) {
			const last_recharged_inputs = _this.fields.last_recharged_form.querySelectorAll('input');

			if (last_recharged_inputs.length) {
				for (let element of last_recharged_inputs) {
					element.addEventListener('change', () => {
						_this.fields.last_recharged_form.submit();
					});
				}
			}
		}

		// Toggle show/hide sms notify form group
		if (_this.fields.sms_notify_trigger) {
			_this.fields.sms_notify_trigger.addEventListener('change', (event) => {
				_this.mr.state.sms_notify.enabled = !!event.target.checked;
				if (event.target.checked) {
					_this.showSMSNotifyFields(_this.mr.state.operator);
					_this.fields.sms_notify_form_group.style.height = 'auto';
					_this.buildSMSNotifyForm();
				} else {
					_this.fields.sms_notify_form_group.style.height = 0;
					_this.removeSMSNotifyForm();
				}
			});
		}

		if (_this.fields.sms_notify_input) {
			_this.fields.sms_notify_input.addEventListener('keyup', (event) => {
				const prefix = _this.mr.sanitizePhoneNumber(_this.mr.state.sms_notify.prefix);
				const value = _this.mr.stripNonNumericCharacters(event.target.value);
				const sms_notify_full_number = prefix + value;

				_this.fields.sms_notify_input.value = value;
				_this.fields.sms_notify_input_mask.innerHTML = _this.formatSMSPhoneExample(sms_notify_full_number);

				_this.mr.state.sms_notify.phone = value;

				this.buildSMSNotifyForm();
			});
		}

		// Update sms notify message characters left value
		if (_this.fields.sms_notify_message) {
			_this.fields.sms_notify_message.addEventListener('keyup', (event) => {
				const {
					text,
					char_count_left
				} = _this.getMessageSize(event.target.value, 160);
				const char_text = char_count_left < 1 ? '0' : char_count_left.toString();

				event.target.value = text;
				_this.fields.sms_notify_message_char_left.innerText = s.it('CHARACTERS_LEFT', {'number': char_text});

				_this.mr.state.sms_notify.message = text;

				this.buildSMSNotifyForm();
			});
		}

		// Toggle show/hide email notify form group
		if (_this.fields.email_notify_trigger) {
			_this.fields.email_notify_trigger.addEventListener('change', (event) => {
				_this.mr.state.email_notify.enabled = !!event.target.checked;
				if (event.target.checked) {
					_this.showEmailNotifyFields();
					_this.fields.email_notify_form_group.style.height = 'auto';
					_this.buildEmailNotifyForm();
				} else {
					_this.fields.email_notify_form_group.style.height = 0;
					_this.removeEmailNotifyForm();
				}
			});
		}

		if (_this.fields.email_notify_input) {
			_this.fields.email_notify_input.addEventListener('keyup', (event) => {
				_this.mr.state.email_notify.address = event.target.value;
				this.buildEmailNotifyForm();
			});
		}

		// Update email notify message characters left value
		if (_this.fields.email_notify_message) {
			_this.fields.email_notify_message.addEventListener('keyup', (event) => {
				const {
					text,
					char_count_left
				} = _this.getMessageSize(event.target.value, 320);
				const char_text = char_count_left < 1 ? '0' : char_count_left.toString();

				event.target.value = text;
				_this.fields.email_notify_message_char_left.innerText = s.it('CHARACTERS_LEFT', {'number': char_text});

				_this.mr.state.email_notify.message = _this.escapeHtml(text);

				this.buildEmailNotifyForm();
			});
		}

		if (_this.fields.submit_button) {
			_this.fields.submit_button.addEventListener('click', (event) => {
				event.preventDefault();

				if (event.target.classList.contains('disabled')) {
					_this.mr.emptyElement(_this.fields.submit_message_holder);
					_this.mr.updateSubmitMessage();
				} else {
					_this.fields.submit_button.classList.add('disabled');
					_this.fields.form.submit();
				}
			});
		}
	}

	/**
	 * Handles account fields events.
	 */
	bindAccountFieldsEvents() {
		const _this = this;

		if (_this.fields.account_fields_holder) {
			const inputs = _this.fields.account_fields_content.querySelectorAll('[data-account-field-key]');

			inputs.forEach((element) => {
				element.addEventListener('focus', (event) => {
					event.target.closest('.input-group').classList.add('color-primary');
				});
				element.addEventListener('blur', (event) => {
					event.target.closest('.input-group').classList.remove('color-primary');
				});
				element.addEventListener('input', (event) => {
					const key = event.target.getAttribute('data-account-field-key');
					const value = event.target.value;

					_this.changeAccountField(key, value);
				});
			});
		}
	}

	/**
	 * Handles amount events.
	 */
	bindAmountEvents() {
		const _this = this;

		for (let element of _this.fields.amount_content.querySelectorAll('.amount')) {
			element.addEventListener('click', (event) => {
				event.preventDefault();
				const amount_button = event.target.closest('.amount');
				const amount_value = amount_button.value ? amount_button.value : amount_button.getAttribute('data-value');
				if (!amount_button.classList.contains('active')) {
					_this.changeAmount(amount_value);
				}
			});
		}

		if (document.querySelector('#amount-custom-range-input')) {
			document.querySelector('#amount-custom-range-input').addEventListener('keyup', (event) => {
				_this.changeAmount(event.target.value);
			});
		}
	}

	/**
	 * Handles the change country event.
	 * @param {String} 	country_code
	 */
	changeCountry(country_code) {
		// console.log('BuyMobileRecharge changeCountry(%o)', country_code);
		const _this = this;

		if (this.fetcher.get_received_amount) {
			this.fetcher.get_received_amount.abort();
		}

		_this.initial_state.country.code = null;

		_this.mr.hideElement(_this.fields.amount_holder);
		_this.mr.emptyElement(_this.fields.amount_content);
		_this.mr.hideElement(_this.fields.notify_holder);
		_this.mr.hideElement(_this.fields.sms_notify_holder);
		_this.mr.hideElement(_this.fields.email_notify_holder);
		_this.mr.emptyElement(_this.fields.submit_message_holder);

		if (_this.fields.submit_button) {
			_this.fields.submit_button.classList.add('disabled');
		}

		if (_this.location === 'buy_mr') {
			_this.updateHeroTitle(country_code);
		}

		_this.mr.changeCountry(country_code)
			.then((response) => {
				if (_this.location === 'buy_mr') {
					_this.updateSEOContent(response.state.country, {});
				}

				if (response && response.operator_groups) {
					_this.mr.updateCountryOperators(response.operator_groups);

					if (response.operator_groups.length >= 3) {
						_this.mr.createOperatorGroupBackButton();
					}
				}

				if (!_this.showOperatorGroup()) {
					return;
				}

				if (response.operator_groups && response.operator_groups.length === 1 || _this.display_preselected_operator) {
					// only 1 operator
					if (response.operator_groups[0].operators.length > 1) {
						// group operator => show child operators
						_this.handleOperatorGroupEvent(_this.fields.operator_content.querySelector('.operator_button'));
					} else {
						// normal operator => show details
						_this.changeOperator(response.operator_groups[0].operators[0].id);
					}
				}

				if (response.state.country?.name) {
					if (response.operator_groups && response.operator_groups.length > 0) {
						if (_this.fields.sms_notify_input) _this.fields.sms_notify_input.value = '';

						_this.mr.showElement(_this.fields.operator_holder);
						_this.mr.showElement(_this.fields.submit_holder);
					}
				} else {
					_this.mr.hideElement(_this.fields.operator_holder);
					_this.mr.hideElement(_this.fields.submit_holder);
				}

				// update url
				let new_url = _this.base_url;
				let new_url_params = {};
				if (response.state.country?.name) {
					new_url += `/${encodeURIComponent(response.state.country.name)}`;
				}
				if (_this.banner_promo_code) {
					new_url_params._banner = _this.banner_promo_code;
				}
				window.history.replaceState(response.state, 'Title', s.url(new_url, new_url_params));
			});
	}

	/**
	 * Handles the change operator event.
	 * @param {String} 	operator_id
	 */
	changeOperator(operator_id) {
		// console.log('BuyMobileRecharge changeOperator(%o)', operator_id);
		const _this = this;
		const choose_another_operator = _this.fields.operator_content.querySelector('#choose_another_operator');

		if (choose_another_operator) {
			choose_another_operator.classList.remove('active', 'on_active_display_block');
		}

		// stop unnecessary requests
		if (_this.fetcher.get_received_amount) {
			_this.fetcher.get_received_amount.abort();
		}

		if (_this.fields.form_fields) {
			_this.fields.form_fields.innerHTML = '';
		}

		if (_this.fields.submit_button) {
			_this.fields.submit_button.classList.add('disabled');
		}

		_this.mr.emptyElement(_this.fields.submit_message_holder);

		_this.mr.changeOperator(operator_id)
			.then(function (response) {
				const country = response.state.country;
				const operator = response.operator;

				_this.initial_state.operator.id = null;

				if (choose_another_operator) {
					choose_another_operator.classList.add('active', 'on_active_display_block');
				}

				_this.bindAccountFieldsEvents();
				_this.createAmountSection(operator);
				_this.changeNotifySection(operator);

				if (_this.location === 'buy_mr') {
					_this.updateSEOContent(country, operator);
				}

				// update url
				let new_url = _this.base_url;
				let new_url_params = {};
				if (typeof country.name !== 'undefined') {
					new_url += `/${encodeURIComponent(country.name)}`;
				}
				if (typeof operator.name !== 'undefined') {
					new_url += `/${encodeURIComponent(operator.name)}`;
				}
				if (_this.banner_promo_code) {
					new_url_params._banner = _this.banner_promo_code;
				}
				window.history.replaceState(response.state, 'Title', s.url(new_url, new_url_params));

				if (_this.mr.state.supplier_operator_fields.length) {
					const selected_account_fields = _this.initial_state.account_fields.selected;

					if (!_this.mr.checkEmptyObject(selected_account_fields)) {
						for (const selected_field_key in selected_account_fields) {
							if (selected_account_fields.hasOwnProperty(selected_field_key)) {
								const selected_field_value = selected_account_fields[selected_field_key];
								_this.changeAccountField(selected_field_key, selected_field_value);
							}
						}
					} else {
						_this.mr.state.supplier_operator_fields.forEach((field) => {
							if (_this.mr.state.account_fields[field.field_key]?.value) {
								_this.changeAccountField(field.field_key, _this.mr.state.account_fields[field.field_key].value);
							}
						});
					}
				}
			})
			.catch((error) => {
				throw error;
			});
	}

	/**
	 * Handles the change account field event.
	 * @param {String} 	account_field_key
	 * @param {String} 	account_field_value
	 */
	changeAccountField(account_field_key, account_field_value) {
		// console.log('BuyMobileRecharge changeAccountField key: (%o), value: (%o)', account_field_key, account_field_value);
		if (this.fetcher.get_received_amount) {
			this.fetcher.get_received_amount.abort();
		}

		if (this.fields.submit_button) {
			this.fields.submit_button.classList.add('disabled');
		}

		this.mr.hideElement(this.fields.amount_banner_holder);

		this.mr.changeAccountField(account_field_key, account_field_value)
			.then((response) => {
				switch (response.field.type) {
					case 'phone':
						const phone_number = response.field.prefix + response.state.account_fields[account_field_key].value;
						this.updateSMSNotifyLabels(this.mr.formatPhoneExample(phone_number));
						break;
					case 'email':
					case 'nauta':
						this.updateEmailNotifyLabels(account_field_value);
						break;
				}
			})
			.catch((response) => {
				switch (response.field.type) {
					case 'phone':
						const phone_number = response.field.prefix + response.state.account_fields[account_field_key].value;
						this.updateSMSNotifyLabels(this.mr.formatPhoneExample(phone_number));
						break;
					case 'email':
					case 'nauta':
						this.updateEmailNotifyLabels('');
						break;
				}

				this.mr.emptyElement(this.fields.form_fields);
			});

		this.updateAmountValues();
	}

	/**
	 * Handles the select amount event.
	 * @param {String|int} 	amount
	 */
	changeAmount(amount) {
		// console.log('BuyMobileRecharge changeAmount(%o)', amount);
		const _this = this;

		// stop unnecessary requests
		if (_this.fetcher.get_received_amount) {
			_this.fetcher.get_received_amount.abort();
		}

		_this.initial_state.amount = null;

		if (document.querySelector('#amount-custom-range-input')) {
			const form_group = document.querySelector('#amount-custom-range-input').closest('.form-group');
			if (form_group) {
				const form_text = form_group.querySelector('.form-text');
				if (form_text) {
					form_text.style.display = 'none';
					form_text.innerHTML = '';
				}
			}
		}

		_this.validateAmount(amount, _this.mr.state.operator)
			.then((response) => {
				if (_this.fields.submit_button) {
					_this.fields.submit_button.classList.remove('disabled');
				}

				// update url
				let new_url = _this.base_url;
				let new_url_params = {};
				new_url += `/${encodeURIComponent(_this.mr.state.country.name)}`;
				new_url += `/${encodeURIComponent(_this.mr.state.operator.name)}`;

				if (_this.banner_promo_code) {
					new_url_params._banner = _this.banner_promo_code;
				}

				if (response.amount.flags) {
					_this.mr.state.operator.amount_flags = response.amount.flags;
				}

				if (_this.mr.state.operator.value_type === 'fixed') {
					_this.mr.state.amount = response.amount;
					_this.mr.showElement(_this.fields.amount_banner_holder);

					_this.fields.amount_banner_content.querySelectorAll('.banner-content').forEach((banner) => {
						if (banner.getAttribute('data-sale_value') === _this.mr.state.amount.sale_value) {
							banner.style.display = '';
						} else {
							banner.style.display = 'none';
						}
					});
				} else {
					_this.mr.state.amount = {
						'sale_value': response.amount
					};
					if (document.querySelector('#amount-custom-range-input')) {
						document.querySelector('#amount-custom-range-input').value = _this.mr.state.amount.sale_value;
						const form_group = document.querySelector('#amount-custom-range-input').closest('.form-group');
						if (form_group) {
							const form_text = form_group.querySelector('.form-text');
							if (form_text) {
								form_text.style.display = '';
								form_text.innerHTML = response.message;
							}
						}
					}
				}

				window.history.replaceState(_this.mr.state, 'Title', s.url(new_url, new_url_params));

				_this.mr.emptyElement(_this.fields.submit_message_holder);

				_this.buildProductForm();
			})
			.catch((response) => {
				if (_this.fields.submit_button) {
					_this.fields.submit_button.classList.add('disabled');
				}

				_this.mr.hideElement(_this.fields.amount_banner_holder);

				if (response.message && document.querySelector('#amount-custom-range-input')) {
					const form_group = document.querySelector('#amount-custom-range-input').closest('.form-group');
					if (form_group) {
						const form_text = form_group.querySelector('.form-text');
						if (form_text) {
							form_text.style.display = '';
							form_text.innerHTML = response.message;
						}
					}
				}
			});
	}

	/**
	 * Handles operator events.
	 * @param {Object} 	operator_button
	 */
	bindOperatorEvent(operator_button) {
		const button_parent = operator_button.closest('.operator');

		if (!button_parent.classList.contains('active')) {
			switch (operator_button.type) {
				case 'button':
					this.handleOperatorButtonEvent(operator_button);
					break;

				default:
					// if no type, default to a div selector equivalent for a group selector
					this.handleOperatorGroupEvent(operator_button);
					break;
			}
			this.mr.scrollToTarget('#form-fields');
		}
	}

	/**
	 * Handles operator events.
	 * @param {Object} 	operator_button
	 */
	handleOperatorButtonEvent(operator_button) {
		const operator_buttons_from_group = this.fields.operator_options_content.querySelectorAll('button.operator_button');

		if (operator_buttons_from_group) {
			for (let element of operator_buttons_from_group) {
				element.closest('.operator').classList.remove('active');
				element.closest('.operator').classList.add('inactive');
			}

			const selected_operator_el = operator_button.closest('.operator');
			if (selected_operator_el) {
				selected_operator_el.classList.remove('inactive');
				selected_operator_el.classList.add('active');
			}
		}

		this.changeOperator(operator_button.value);
	}

	/**
	 * Handles operator group events.
	 * @param {Object} 	operator_button
	 */
	handleOperatorGroupEvent(operator_button) {
		const operator_group_name = operator_button.getAttribute('data-operator-group');
		const operator_groups = this.mr.cache[this.mr.state.country.code];
		const operator_group = this.mr.findOperatorGroup(operator_groups, operator_group_name);

		if (operator_group && operator_group.operators.length > 1) {
			const new_url = `${this.base_url}/${encodeURIComponent(this.mr.state.country.name)}/?op_group=${encodeURIComponent(operator_group_name)}`;

			window.history.replaceState(this.mr.state, 'Title', s.url(new_url, {}));

			this.mr.hideElement(this.fields.operator_content);
			this.mr.hideElement(this.fields.account_fields_holder);
			this.mr.updateOperatorGroup(operator_group);
		}
	}

	/**
	 * Handles display of the operator group.
	 * @return {Boolean}
	 */
	showOperatorGroup() {
		try {
			this.mr.showElement(this.fields.operator_content);
			this.mr.hideElement(this.fields.operator_options_content);

			const url_params = new URLSearchParams(window.location.search);
			const selected_op_group = url_params.get('op_group');

			if (!this.initial_preselect_operator_group && selected_op_group) {
				// Preselect operator group from query string
				// URL is like this: buy/mobile_recharge/Mexico?op_group=Movistar
				this.initial_preselect_operator_group = true;
				this.mr.preselectOperatorGroup(selected_op_group);
				this.mr.showElement(this.fields.submit_holder);
				return false;
			}

			if (this.initial_state.operator.id) {
				// Preselect operator group and operator from initial state
				// URL is like this: /buy/mobile_recharge/Mexico/Movistar%20Internet
				const operator_groups = this.mr.cache[this.mr.state.country.code];
				const operator_group = this.mr.findOperatorGroupByOperatorID(operator_groups, this.initial_state.operator.id);

				if (operator_group) {
					this.mr.preselectOperatorGroup(operator_group.group, this.initial_state.operator.id);
				}
			}

			return true;
		} catch (error) {
			console.error('Error on showOperatorGroup', error);
			return true;
		}
	}

	/**
	 * Check if all account fields are valid.
	 */
	validateAccountFields() {
		let invalid_fields = [];

		if (this.mr.state.account_fields.keys.length) {
			this.mr.state.account_fields.keys.forEach(field => {
				const field_input = document.querySelector(`input[data-account-field-key='${field}']`);
				const field_is_invalid = field_input.getAttribute('aria-invalid') === 'true';

				if (field_is_invalid) {
					invalid_fields.push(field_is_invalid);
				}
			});
		}

		return !invalid_fields.length;
	}

	/**
	 * Create the amount content for an operator.
	 * @param {Object} 	operator
	 */
	createAmountSection(operator) {
		// console.log('BuyMobileRecharge createAmountSection(%o)', operator);
		let key = 1;
		let title_key = 1;
		let is_mobile = false;

		this.mr.emptyElement(this.fields.amount_content);
		this.mr.emptyElement(this.fields.amount_banner_content);

		switch (operator.value_type) {
			case 'fixed':
				// Show the best offer as the first value in ascending order
				if (operator.values.length > 1) {
					operator.values.sort((a, b) => {
						const flag_a = a.flags.best_offer === true;
						const flag_b = b.flags.best_offer === true;
						const value_a = a.unaltered_local_value;
						const value_b = b.unaltered_local_value;

						if (flag_a && !flag_b) {
							return -1;
						}
						if (!flag_a && flag_b) {
							return 1;
						}
						if (value_a === value_b) {
							return 0;
						}
						return value_a - value_b;
					});
				}

				operator.values.forEach((value) => {
					let top_part = document.createElement('div');
					let bottom_part = document.createElement('div');
					let col = document.createElement('div');
					let content = '';
					let promo_content = '';
					let group;
					top_part.classList.add('top-part', 'd-flex', 'flex-column', 'bundle-top');
					col.classList.add('col-6', 'mb-20');

					if (value.language_text_promo) {
						if (this.new_value_promo_format) {
							promo_content += `<div class='fs-14 mt-10'>${value.language_text_promo}</div>`;
						} else {
							promo_content += `<div class='fs-14 mt-10'>+ ${s.it('BONUS')}:</div>`;
							promo_content += `<div class='d-flex flex-column justify-content-center fs-16 font-weight-bold'>${value.language_text_promo}</div>`;
						}
					}

					switch (operator.operator_type) {
						case 'internet':
						case 'gift_card':
						case 'credit':
							col.classList.add('col-md-4', 'col-lg-3');

							content += `<span class='fs-14'>${s.it('AMOUNT_RECEIVED')}:</span>`;
							content += `<span class='fs-28 lh-1 mt-5'>${value.local_value}</span>`;
							content += `<span class='fs-14'>${value.local_currency.code}</span>`;
							break;

						case 'internet_bundle':
						case 'gift_card_bundle':
						case 'bundle':
							col.classList.remove('col-6');
							col.classList.add('col-12', 'col-sm-6');
							content += '<button type="button" onclick="return false;"';
							content += 'class="bundle_extra_toggle bundle_' + key + ' d-flex justify-content-between align-items-center p-20';
							content += ' btn btn-link ';
							content += is_mobile === true ? '' : 'flipped_chevron' + '">';
							content += '<h3 class="mb-0 w-100">';
							content += value.title_text ? value.title_text : operator.name + ' #' + title_key;
							content += '</h3>';
							content += '</button>';
							if (value.language_text) {
								content += '<div class="bundle_language_var_' + key + ' collapse ' + (is_mobile === true ? '' : 'show');
								content += ' text-left px-20 pb-20 language_var_holder"' + (is_mobile === true ? '' : 'aria-expanded="true"');
								content += '>';
								content += '<div>';
								content += value.language_text;
								content += '</div>';
								content += promo_content;

								content += '</div>';
							}
							if (!value.title_text) {
								title_key++;
							}
							key++;
							break;

						default:
					}

					if (value.incl_taxes > 0) {
						const text_incl_taxes = s.it('INCLUDING_LOCAL_TAXES', {
							'amount_excluding_tax': s.format_money(
								value.incl_taxes,
								false,
								2,
								value.local_currency
							)
						});
						content += `<span class='fs-10 mt-10'>${text_incl_taxes}</span>`;
					}

					if (operator.operator_type === 'credit') {
						content += promo_content;
					}

					let existing_content = top_part.innerHTML;
					top_part.innerHTML = existing_content + content;

					const showAmountOldValue = (value) => {
						return `
							<span class='fs-14 font-weight-light' style='text-decoration: line-through; opacity: 0.6;'>
								${ s.format_money(value.flags['old_value']) }
							</span>
						`;
					};

					let bottom_part_discount = '';
					if (value.max_discount > 0) {
						bottom_part_discount = `<span class='fs-14 align-middle' style='text-decoration:line-through'>${s.format_money(value.sale_value)}</span>`;
					}
					bottom_part.classList.add('bottom-part', 'd-flex', 'flex-column');
					bottom_part.innerHTML = `
						<div class='fs-14'>${s.it('AMOUNT_CHARGED')}:</div>
						<div>
							<span class='fs-16'>${bottom_part_discount} ${s.format_money(value.sale_value)}</span>
							${value.flags.hasOwnProperty('old_value') ? showAmountOldValue(value) : ''}
						</div>
					`;

					group = document.createElement('button');
					group.classList.add('d-flex', 'flex-column', 'justify-content-center', 'align-items-stretch', 'amount');
					group.value = value.local_value;
					group.type = 'button';
					group.setAttribute('disabled', '');
					group.setAttribute('tabindex', 0);

					let banner_icons = document.createElement('div');
					banner_icons.classList.add('banner-icons-holder', 'd-flex');

					let operator_banners = this.getAmountBanners(value);
					operator_banners.forEach(banner => {
						if (banner.icon) {
							banner_icons.appendChild(banner.icon);
						}
						if (banner.content) {
							this.fields.amount_banner_content.appendChild(banner.content);
						}
					});

					group.appendChild(banner_icons);
					group.appendChild(top_part);
					group.appendChild(bottom_part);
					col.appendChild(group);

					this.fields.amount_content.appendChild(col);
				});
				break;

			case 'range':
				let min_value = operator.values[0];
				let max_value = operator.values[1];
				let content = `
					<div class='col-sm col-lg-6'>
						<div class='form-group mb-20'>
							<div class='input-group'>
								<div class='input-group-prepend'>
									<span class='input-group-text'>${s.h(s.options.currency.code)}</span>
								</div>
								<input id='amount-custom-range-input' type='number' class='form-control' step='any' min='${s.h(min_value.sale_value)}' max='${s.h(max_value.sale_value)}' aria-label='Recharge amount' disabled>
							</div>
							<div class='text-center'>
								<img src='${s.url('/images/app/spinner.gif')}' class='spinner mt-5' alt='Loading...' style='display:inline-block;height:24px;'>
								<small class='mt-5 fs-14 form-text text-muted'></small>
							</div>
						</div>
					</div>`;

				this.fields.amount_content.innerHTML = content;

				if (this.fields.amount_content.querySelector('.spinner')) {
					this.fields.amount_content.querySelector('.spinner').style.display = 'none';
				}
				break;

			default:
		}

		this.mr.showElement(this.fields.amount_holder);
		this.mr.showElement(this.fields.amount_banner_holder);
	}

	/**
	 * Enable amount fields.
	 */
	enableAmountValues() {
		if (this.fields.amount_content) {
			const amounts = this.fields.amount_content.querySelectorAll('.amount');
			if (amounts.length > 0) {
				amounts.forEach((element) => {
					element.removeAttribute('disabled');
					element.setAttribute('data-disabled', 'false');
				});
			}

			if (document.querySelector('#amount-custom-range-input')) {
				document.querySelector('#amount-custom-range-input').removeAttribute('disabled');
			}
		}
	}

	/**
	 * Disable amount fields.
	 */
	disableAmountValues() {
		if (this.fields.amount_content) {
			const amounts = this.fields.amount_content.querySelectorAll('.amount');
			if (amounts.length > 0) {
				amounts.forEach((element) => {
					element.setAttribute('disabled', '');
					element.setAttribute('data-disabled', 'true');
				});
			}

			if (document.querySelector('#amount-custom-range-input')) {
				document.querySelector('#amount-custom-range-input').setAttribute('disabled', '');
			}
		}
	}

	/**
	 * Update the amount values after checking if account fields are valid.
	 */
	updateAmountValues() {
		const valid_fields = this.validateAccountFields();

		if (valid_fields) {
			this.enableAmountValues();

			const amounts = this.fields.amount_content.querySelectorAll('.amount');
			// select the first amount card
			if (amounts.length === 1) {
				const amount_value = amounts[0].value ? amounts[0].value : amounts[0].getAttribute('data-value');
				this.changeAmount(amount_value);
			} else {
				if (this.mr.state.amount !== null) {
					if (this.mr.state.operator.value_type === 'fixed') {
						if (this.mr.state.amount?.local_value) {
							this.changeAmount(parseFloat(this.mr.state.amount.local_value));
						}
					} else {
						if (this.mr.state.amount?.sale_value) {
							this.changeAmount(this.mr.state.amount.sale_value);
						}
					}
				}
			}

			if (this.initial_state.amount?.local) {
				this.changeAmount(this.initial_state.amount.local);
			}

			this.bindAmountEvents();

			this.mr.emptyElement(this.fields.submit_message_holder);

			// update url
			let new_url = this.base_url;
			let new_url_params = {};
			new_url += `/${encodeURIComponent(this.mr.state.country.name)}`;
			new_url += `/${encodeURIComponent(this.mr.state.operator.name)}`;

			if (this.banner_promo_code) {
				new_url_params._banner = this.banner_promo_code;
			}
			window.history.replaceState(this.mr.state, 'Title', s.url(new_url, new_url_params));
		} else {
			this.disableAmountValues();

			if (this.fields.submit_button) {
				this.fields.submit_button.classList.add('disabled');
			}
		}
	}

	/**
	 * Handles validate amount and display message.
	 * @param {String} 	amount
	 * @param {Object} 	operator
	 * @return {Promise}
	 */
	validateAmount(amount, operator) {
		let return_amount = null;
		return new Promise((resolve, reject) => {
			this.mr.state.amount = {};
			switch (operator.value_type) {
				case 'fixed':
					this.fields.amount_content.querySelectorAll('.amount').forEach(element => {
						element.classList.remove('active', 'inactive');
					});
					this.mr.state.operator.values.forEach((value) => {
						if (parseFloat(amount) === parseFloat(value.local_value)) {
							return_amount = value;
						}
					});
					if (return_amount) {
						this.fields.amount_content.querySelectorAll('.amount').forEach(element => {
							element.classList.add('inactive');
						});

						const amount_with_value = this.fields.amount_content.querySelector(`.amount[value='${s.h(amount)}']`);
						if (amount_with_value) {
							amount_with_value.classList.remove('inactive');
							amount_with_value.classList.add('active');
						}

						const amount_with_data_value = this.fields.amount_content.querySelector(`.amount[data-value='${s.h(amount)}']`);
						if (amount_with_data_value) {
							amount_with_data_value.classList.remove('inactive');
							amount_with_data_value.classList.add('active');
						}

						resolve({'amount': return_amount});
					} else {
						reject({
							'message': 'Invalid amount.',
							'amount': amount
						});
					}
					break;

				case 'range':
					if (this.fields.submit_button) {
						this.fields.submit_button.classList.add('disabled');
					}

					let min_amount = this.mr.state.operator.values[0];
					let max_amount = this.mr.state.operator.values[1];

					const amount_spinner = this.fields.amount_content.querySelector('.spinner');
					if (amount_spinner) {
						amount_spinner.style.display = '';
					}

					if (parseFloat(amount) >= parseFloat(min_amount.sale_value) && parseFloat(amount) <= parseFloat(max_amount.sale_value)) {
						const form_data = new FormData();
						form_data.append('action', 'get_received_amount');
						form_data.append('operator_id', this.mr.state.operator.id);
						form_data.append('amount', amount);

						this.fetcher.get_received_amount = s.common.fetcher(
							s.url('/buy/mobile_recharge_checks'),
							{
								method: 'post',
								body: form_data
							}
						);

						this.fetcher.get_received_amount.ready
							.then((response) => {
								if (response) {
									if (amount_spinner) {
										amount_spinner.style.display = 'none';
									}
									resolve({
										'status': response.status,
										'message': response.message,
										'amount': amount
									});
								}
							})
							.catch(error => {
								if (error.name !== 'AbortError') {
									if (amount_spinner) {
										amount_spinner.style.display = 'none';
									}
									reject({
										'status': false,
										'message': 'Invalid amount.',
										'amount': amount
									});
								}
							});
					} else {
						this.mr.state.amount = null;
						if (amount_spinner) {
							amount_spinner.style.display = 'none';
						}

						reject({
							'message': `Amount must be between ${s.h(s.format_money(min_amount.sale_value))} and ${s.h(s.format_money(max_amount.sale_value))}`,
							'min': min_amount.sale_value,
							'max': max_amount.sale_value,
							'amount': amount
						});
					}

					break;

				default:
					reject({'message': 'Invalid state'});
			}
		});
	}

	/**
	 * Get amount banners content.
	 * @param {Object} 	amount
	 */
	getAmountBanners(amount) {
		// console.log('BuyMobileRecharge getAmountBanners(%o)', amount);
		let amount_banners = [];

		if (amount.flags) {
			for (let banner_type in amount.flags) {
				if (amount.flags.hasOwnProperty(banner_type)) {
					if (banner_type === 'operator_outage') {
						const banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
						banner_icon.classList.add('banner-icon', 'ml-5');
						banner_icon.setAttribute('data-banner_type', banner_type);
						banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--notice"></use>';

						const banner_content = document.createElement('div');
						banner_content.classList.add('banner-content', 'mb-10');
						banner_content.setAttribute('data-sale_value', amount.sale_value);
						banner_content.style.display = 'none';
						banner_content.classList.add('banner-content-new-operator');
						banner_content.innerHTML += `<div class='banner-message'>${amount.flags[banner_type]}</div>`;

						amount_banners.push({
							'icon': banner_icon,
							'content': banner_content
						});
					}

					if (banner_type === 'best_offer') {
						const banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
						banner_icon.classList.add('banner-icon', 'ml-5');
						banner_icon.setAttribute('data-banner_type', banner_type);
						banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--bestdeal"></use>';

						amount_banners.push({
							'icon': banner_icon
						});
					}
				}
			}
		}

		if ('max_discount' in amount && amount.max_discount > 0) {
			let banner_icon;
			banner_icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			banner_icon.classList.add('banner-icon', 'ml-5');
			banner_icon.setAttribute('data-banner_type', 'discount');
			banner_icon.innerHTML += '<use xlink:href="#svg_icon-label--promo-new"></use>';

			amount_banners.push({
				'icon': banner_icon,
				'content': ''
			});
		}

		return amount_banners;
	}

	/**
	 * Handles the changes for notification section.
	 * @param {Object} 	operator
	 */
	changeNotifySection(operator) {
		const sms_notification = operator.notifications.sms;
		const email_notification = operator.notifications.email;

		// If no sms notification and no email notification, hide the #notify-holder
		if (!sms_notification.enabled && !email_notification.enabled) {
			this.mr.hideElement(this.fields.notify_holder);
		}

		if (sms_notification.enabled) {
			this.resetSMSNotifyFields();
			this.showSMSNotifyFields(operator);
		} else {
			this.hideSMSNotifyFields();
		}

		if (email_notification.enabled && this.location === 'buy_gift_card') {
			this.resetEmailNotifyFields();
			this.showEmailNotifyFields();
		} else {
			this.hideEmailNotifyFields();
		}
	}

	/**
	 * Handle display of the SMS notification fields and sms notification state.
	 * @param {Object} 	operator
	 */
	showSMSNotifyFields(operator) {
		this.mr.showElement(this.fields.notify_holder);
		this.mr.showElement(this.fields.sms_notify_holder);

		if (this.mr.state.account_fields.types.includes('phone')) {
			// the sms notify section will use the account field phone input value
			this.mr.hideElement(this.fields.sms_notify_input_holder);
			this.mr.hideElement(this.fields.sms_notify_input);
		} else {
			// the sms notify section will use that notification phone input value
			this.mr.showElement(this.fields.sms_notify_input_holder);
			this.mr.showElement(this.fields.sms_notify_input);

			const sms_notification_prefix = operator.notifications.sms.prefix ?? '';
			const sms_notification_mask = operator.notifications.sms.mask ?? '';

			this.mr.state.sms_notify.prefix = sms_notification_prefix;
			this.mr.state.sms_notify.mask = sms_notification_mask;

			if (this.fields.sms_notify_input_prefix) {
				this.fields.sms_notify_input_prefix.innerHTML = s.h(sms_notification_prefix);
			}

			if (this.fields.sms_notify_input_mask) {
				this.fields.sms_notify_input_mask.innerHTML = this.formatSMSPhoneExample('');
			}

			this.updateSMSNotifyLabels('');
		}
	}

	/**
	 * Handle hide of the SMS notification fields and sms notification state.
	 */
	hideSMSNotifyFields() {
		this.mr.hideElement(this.fields.sms_notify_holder);

		this.mr.state.sms_notify.enabled = false;
		this.mr.state.sms_notify.phone = '';
		this.mr.state.sms_notify.message = '';

		this.removeSMSNotifyForm();
	}

	/**
	 * Update the SMS notification labels.
	 * @param {String} 	phone_number
	 */
	updateSMSNotifyLabels(phone_number) {
		if (this.fields.sms_notify_trigger_label) {
			if (this.mr.state.account_fields.types.includes('phone')) {
				const destination = phone_number ? phone_number : this.mr.formatPhoneExample('');
				this.fields.sms_notify_trigger_label.innerHTML = s.it('SMS_NOTIFICATION_LABEL_SEND_TO', {'destination': destination});
			} else {
				this.fields.sms_notify_trigger_label.innerHTML = s.it('SMS_NOTIFICATION_LABEL_SEND');
			}
		}
	}

	/**
	 * Resets the SMS notification fields and sms notification state.
	 */
	resetSMSNotifyFields() {
		if (this.fields.sms_notify_trigger) {
			this.fields.sms_notify_trigger.checked = false;
			this.fields.sms_notify_form_group.style.height = 0;
			this.updateSMSNotifyLabels('');
			this.fields.sms_notify_input.value = '';
			this.fields.sms_notify_message.value = '';

			this.mr.state.sms_notify.prefix = '';
			this.mr.state.sms_notify.mask = '';
			this.mr.state.sms_notify.phone = '';
		}
	}

	/**
	 * Removes the SMS notification product data form elements.
	 */
	removeSMSNotifyForm() {
		const form_notify_sms_phone = this.fields.form_fields.querySelector('input[name="product_data[sms_notify_phone]"]');
		const form_notify_sms_message = this.fields.form_fields.querySelector('input[name="product_data[sms_notify_message]"]');

		if (form_notify_sms_phone) {
			form_notify_sms_phone.remove();
		}

		if (form_notify_sms_message) {
			form_notify_sms_message.remove();
		}
	}

	/**
	 * Show the email notification fields.
	 */
	showEmailNotifyFields() {
		this.mr.showElement(this.fields.notify_holder);
		this.mr.showElement(this.fields.email_notify_holder);

		if (this.mr.state.account_fields.types.includes('email') || this.mr.state.account_fields.types.includes('nauta')) {
			// the email notify section will use that account field email/nauta input value
			this.mr.hideElement(this.fields.email_notify_input_holder);
			this.mr.hideElement(this.fields.email_notify_input);
		} else {
			// the email notify section will use that notification email input value
			this.mr.showElement(this.fields.email_notify_input_holder);
			this.mr.showElement(this.fields.email_notify_input);

			this.updateEmailNotifyLabels('');
		}
	}

	/**
	 * Handle hide of the SMS notification fields and sms notification state.
	 */
	hideEmailNotifyFields() {
		this.mr.hideElement(this.fields.email_notify_holder);

		this.mr.state.email_notify.enabled = false;
		this.mr.state.email_notify.address = '';
		this.mr.state.email_notify.message = '';

		this.removeEmailNotifyForm();
	}

	/**
	 * Update the email notification labels.
	 * @param {String} 	email_address
	 */
	updateEmailNotifyLabels(email_address) {
		if (this.fields.email_notify_trigger_label) {
			if ((this.mr.state.account_fields.types.includes('email') || this.mr.state.account_fields.types.includes('nauta')) && email_address) {
				this.fields.email_notify_trigger_label.innerHTML = s.it('EMAIL_NOTIFICATION_LABEL_SEND_TO', {'destination': email_address});
			} else {
				this.fields.email_notify_trigger_label.innerHTML = s.it('EMAIL_NOTIFICATION_LABEL_SEND');
			}
		}
	}

	/**
	 * Resets the email notification fields and email notification state.
	 */
	resetEmailNotifyFields() {
		if (this.fields.email_notify_trigger) {
			this.fields.email_notify_trigger.checked = false;
			this.fields.email_notify_form_group.style.height = 0;
			this.updateEmailNotifyLabels('');
			this.fields.email_notify_input.value = '';
			this.fields.email_notify_message.value = '';

			this.mr.state.email_notify.address = '';
			this.mr.state.email_notify.message = '';
		}
	}

	/**
	 * Removes the email notification product data form elements.
	 */
	removeEmailNotifyForm() {
		const form_notify_email_address = this.fields.form_fields.querySelector('input[name="product_data[email_notify_address]"]');
		const form_notify_email_message = this.fields.form_fields.querySelector('input[name="product_data[email_notify_message]"]');

		if (form_notify_email_address) {
			form_notify_email_address.remove();
		}

		if (form_notify_email_message) {
			form_notify_email_message.remove();
		}
	}

	/**
	 * Builds the SMS notification product data form elements.
	 */
	buildSMSNotifyForm() {
		if (this.mr.state.sms_notify.enabled) {
			this.removeSMSNotifyForm();

			let sms_notify_full_number;
			let sms_notify_message = this.mr.state.sms_notify.message ? this.mr.state.sms_notify.message : '';

			if (this.mr.state.account_fields.types.includes('phone')) {
				// use the account fields phone input for the product_data[sms_notify_phone]
				const phone_field = this.mr.state.supplier_operator_fields.find((field) => field.type === 'phone');
				const phone_prefix = this.mr.state.account_fields[phone_field.field_key].prefix;
				const strip_phone_prefix = this.mr.sanitizePhoneNumber(phone_prefix);
				const phone_number = this.mr.state.account_fields[phone_field.field_key].value;

				sms_notify_full_number = strip_phone_prefix + phone_number;
			} else {
				// use the SMS notification input for the product_data[sms_notify_phone]
				const sms_notify_phone_prefix = this.mr.state.sms_notify.prefix;
				const strip_sms_notify_phone_prefix = this.mr.sanitizePhoneNumber(sms_notify_phone_prefix);
				const sms_notify_phone_number = this.mr.state.sms_notify.phone;

				sms_notify_full_number = strip_sms_notify_phone_prefix + sms_notify_phone_number;
			}

			let form_notify_sms_phone = document.createElement('input');
			form_notify_sms_phone.type = 'hidden';
			form_notify_sms_phone.name = 'product_data[sms_notify_phone]';
			form_notify_sms_phone.value = sms_notify_full_number.replace('+', '');

			let form_notify_sms_message = document.createElement('input');
			form_notify_sms_message.type = 'hidden';
			form_notify_sms_message.name = 'product_data[sms_notify_message]';
			form_notify_sms_message.value = sms_notify_message;

			if (sms_notify_full_number && sms_notify_message) {
				this.fields.form_fields.appendChild(form_notify_sms_phone);
				this.fields.form_fields.appendChild(form_notify_sms_message);
			}
		}
	}

	/**
	 * Builds the email notification product data form elements.
	 */
	buildEmailNotifyForm() {
		if (this.mr.state.email_notify.enabled) {
			this.removeEmailNotifyForm();

			let email_notify_address;
			let email_notify_message = this.mr.state.email_notify.message ? this.mr.state.email_notify.message : '';

			if (this.mr.state.account_fields.types.includes('email') || this.mr.state.account_fields.types.includes('nauta')) {
				let email_field;
				if (this.mr.state.account_fields.types.includes('email')) {
					// use the account fields email input for the product_data[email_notify_address]
					email_field = this.mr.state.supplier_operator_fields.find((field) => field.type === 'email');
				}

				if (this.mr.state.account_fields.types.includes('nauta')) {
					// use the account fields nauta input for the product_data[email_notify_address]
					email_field = this.mr.state.supplier_operator_fields.find((field) => field.type === 'nauta');
				}
				email_notify_address = this.mr.state.account_fields[email_field.field_key].value;
			} else {
				// use the email notification input for the product_data[email_notify_address]
				email_notify_address = this.mr.state.email_notify.address;
			}

			let form_notify_email_address = document.createElement('input');
			form_notify_email_address.type = 'hidden';
			form_notify_email_address.name = 'product_data[email_notify_address]';
			form_notify_email_address.value = email_notify_address;

			let form_notify_email_message = document.createElement('input');
			form_notify_email_message.type = 'hidden';
			form_notify_email_message.name = 'product_data[email_notify_message]';
			form_notify_email_message.value = email_notify_message;

			if (email_notify_address && email_notify_message) {
				this.fields.form_fields.appendChild(form_notify_email_address);
				this.fields.form_fields.appendChild(form_notify_email_message);
			}
		}
	}

	/**
	 * Builds the product details form.
	 */
	buildProductForm() {
		if (this.fields.form_fields) {
			this.mr.emptyElement(this.fields.form_fields);

			let form_country_code = document.createElement('input');
			form_country_code.type = 'hidden';
			form_country_code.name = 'product_data[country_code]';
			form_country_code.value = this.mr.state.country.code;
			this.fields.form_fields.appendChild(form_country_code);

			let form_operator_id = document.createElement('input');
			form_operator_id.type = 'hidden';
			form_operator_id.name = 'product_data[operator_id]';
			form_operator_id.value = this.mr.state.operator.id;
			this.fields.form_fields.appendChild(form_operator_id);

			if (this.mr.state.operator.amount_flags && Object.keys(this.mr.state.operator.amount_flags).length) {
				const allowed_flags = ['store_sale_min_limit'];
				Object.keys(this.mr.state.operator.amount_flags)
					.filter((flag) => allowed_flags.includes(flag))
					.forEach((flag) => {
						const form_amount_flag = document.createElement('input');
						form_amount_flag.type = 'hidden';
						form_amount_flag.name = `product_data[${flag}]`;
						form_amount_flag.value = this.mr.state.operator.amount_flags[flag];
						this.fields.form_fields.appendChild(form_amount_flag);
					});
			}

			if (this.mr.state.supplier_operator_fields.length) {
				this.mr.state.supplier_operator_fields.forEach((field) => {
					const field_input = document.querySelector(`input[data-account-field-key='${field.field_key}']`);
					const field_is_invalid = field_input.getAttribute('aria-invalid') === 'true';

					const field_product_data = {
						'field_key': field.field_key,
						'name': field.name,
						'order': field.order,
						'required': field.required,
						'type': field.type,
						'label': field.label,
						'value': field_is_invalid ? '' : field_input.value
					};

					if (field.type === 'phone') {
						const phone_prefix = field.prefix;
						const strip_phone_prefix = this.mr.sanitizePhoneNumber(phone_prefix);
						const full_phone_number = strip_phone_prefix + field_input.value;
						field_product_data.value = full_phone_number.replace('+', '');
					}

					let form_account_field = document.createElement('input');
					form_account_field.type = 'hidden';
					form_account_field.name = 'product_data[account_fields][]';
					form_account_field.value = JSON.stringify(field_product_data);
					this.fields.form_fields.appendChild(form_account_field);

					// TODO remove after changes are done in include/baskets.inc.php regarding remove of $product_data['number'] in set_mr_platform_product_data
					if (field.type === 'phone' || field.type === 'nauta') {
						let form_number = document.createElement('input');
						form_number.type = 'hidden';
						form_number.name = 'product_data[number]';
						form_number.value = field_product_data.value;
						this.fields.form_fields.appendChild(form_number);
					}
				});
			}

			let form_recharge_type = document.createElement('input');
			form_recharge_type.type = 'hidden';
			form_recharge_type.name = 'product_data[recharge_type]';
			form_recharge_type.value = this.mr.state.operator.recharge_type;
			this.fields.form_fields.appendChild(form_recharge_type);

			let form_product_identifier = document.createElement('input');
			form_product_identifier.type = 'hidden';
			form_product_identifier.name = 'product_data[product_identifier]';
			form_product_identifier.value = this.mr.state.operator.product_identifier;
			this.fields.form_fields.appendChild(form_product_identifier);

			let form_quantity = document.createElement('input');
			form_quantity.type = 'hidden';
			form_quantity.name = 'quantity';
			form_quantity.value = this.mr.state.amount.sale_value;
			this.fields.form_fields.appendChild(form_quantity);

			this.buildSMSNotifyForm();
			this.buildEmailNotifyForm();
		}
	}

	/**
	 * Formats phone number to include the country phone prefix used for sms notify section.
	 * @param {String} 	phone_number
	 */
	formatSMSPhoneExample(phone_number) {
		// console.log('BuyMobileRecharge formatSMSPhoneExample(%o)', phone_number);
		let extra_numbers = '';
		let prefix = '';
		let new_number_mask = '';

		if (this.mr.state.sms_notify.prefix) {
			prefix = this.mr.sanitizePhoneNumber(this.mr.state.sms_notify.prefix);
		}

		if (this.mr.state.sms_notify.mask) {
			new_number_mask = this.mr.state.sms_notify.mask
				.replace(this.mr.state.sms_notify.prefix, '')
				.replace(/-/gi, '')
				.replace(/\s/g, '')
				.replace(/[x_]/gi, '#')
				.replace(/[0-9]\?/gi, '#')
				.replace(/\[\^[0-9]]/gi, '#');
		}

		if (phone_number) {
			phone_number = this.mr.sanitizePhoneNumber(phone_number).replace(prefix, '');

			if (phone_number.length > new_number_mask.length) {
				extra_numbers = `<span class='color-danger'>${phone_number.substring(new_number_mask.length, phone_number.length)}</span>`;
				phone_number = phone_number.substring(0, new_number_mask.length);
			}

			new_number_mask = phone_number + new_number_mask.substring(phone_number.length) + extra_numbers;
		}

		return `${prefix}-${new_number_mask}`;
	}

	/**
	 * Returns an object that contains the inputted text and the characters left.
	 * @param {String} 	text
	 * @param {Number} 	limit
	 * @return {Object}
	 */
	getMessageSize(text, limit = 160) {
		if (text.length === 0) {
			return {
				'text': '',
				'char_count_left': limit
			};
		}

		return {
			'text': text.substring(0, limit),
			'char_count_left': limit - text.length
		};
	}

	/**
	 * Convert html characters tags into html entities.
	 * @param {String} 	string
	 * @return {string}
	 */
	escapeHtml(string) {
		const entityMap = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;',
			'/': '&#x2F;',
			'`': '&#x60;',
			'=': '&#x3D;'
		};
		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
			return entityMap[s];
		});
	}

	/**
	 * Updates the hero title based on country changes.
	 * @param {String} 	country_code
	 */
	updateHeroTitle(country_code) {
		const hero_title_selector = document.querySelector('#hero-title');

		if (hero_title_selector) {
			if (!country_code) {
				hero_title_selector.innerHTML = this.initial_hero_title;
			} else {
				let selected_country_name;
				if(this.fields.country_input && this.fields.country_input.dataset.countrySearchInput === '1'){
					selected_country_name = this.fields.country_input.getAttribute('data-country-name');
				} else {
					selected_country_name = this.fields.country.querySelector('option:checked').getAttribute('data-country');
				}
				const top_up_keyword = [
					'JM', 'ES', 'HT', 'TH', 'BS', 'PH', 'WS', 'AF', 'TR', 'RU', 'EG', 'BB', 'FJ', 'MM', 'TT', 'SG',
					'GY', 'PL', 'MY', 'GD', 'KE', 'RW', 'UA', 'ID', 'CN', 'AG', 'CY', 'BE', 'VN', 'BZ', 'BF', 'ZW',
					'KZ', 'KH', 'AS', 'VG', 'DM', 'GE', 'BH', 'BM', 'AO', 'PG', 'AM', 'LT', 'MK', 'MS', 'VU', 'GA',
					'NR', 'SD', 'AN', 'TG'
				];
				const refill_keyword = ['US', 'BI'];
				const airtime_keyword = ['ZA', 'UG', 'MZ'];

				if (top_up_keyword.includes(country_code)) {
					hero_title_selector.innerHTML = s.it('MR_TOP_UP_MOBILE', {'country': selected_country_name});
				} else if (refill_keyword.includes(country_code)) {
					hero_title_selector.innerHTML = s.it('MR_REFILL_MOBILE', {'country': selected_country_name});
				} else if (airtime_keyword.includes(country_code)) {
					hero_title_selector.innerHTML = s.it('MR_AIRTIME_MOBILE', {'country': selected_country_name});
				} else {
					hero_title_selector.innerHTML = s.it('MR_RECHARGE_MOBILE', {'country': selected_country_name});
				}
			}
		}
	}

	/**
	 * Updates the product description bellow the submit button based on country changes.
	 * @param {Object} 	country
	 * @param {Object} 	operator
	 */
	updateSEOContent(country, operator) {
		const seo_content_holder_one = document.querySelector('#seo-content-holder-one');

		if (seo_content_holder_one) {
			const content = seo_content_holder_one.querySelector('.content');

			if (content) {
				if (!country.code) {
					content.innerHTML = this.initial_seo_slot1;
				} else {
					if (country.code === 'CU' && operator.id == 1502 && operator.name == 'Nauta Cuba') {
						// Cuba Nauta SEO content is different from the other countries
						content.innerHTML = s.it('NAUTA_PROMO_BANNER');
					} else {
						content.innerHTML = s.it('MR_TARGET_COUNTRY', {
							'store_name': this.store_name,
							'target_country': country.name
						});
					}
				}
			}
		}
	}
}
